<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>TO</span></p>
<p class="ded1"><span>MY MILLIONS OF FRIENDS</span></p>
<p class="ded1"><span>IN THE SOVIET UNION, WHO,</span></p>
<p class="ded1"><span>WHILE THIS BOOK WAS BEING WRITTEN,</span></p>
<p class="ded1"><span>HAVE BEEN DEFENDING</span></p>
<p class="ded1"><span>OUR COMMON CAUSE.</span></p>
<p class="normal1-1"><span>“Wide is the gate, and broad is the way, that leadeth to destruction.”</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?18ad737b